(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["marame-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('marame-size-guide')) {
    customElements.define('marame-size-guide', class MarameSizeGuide extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-guide-open]');
        this.inline = this.dataset.inline === 'true';
        this.measureOnly = this.dataset.category === 'footwear' && !this.dataset.chartHtml?.trim();
        this.unit = 'cm';
        this.regionProfile = null;
        this.footwearConversionProfile = null;
        this.canonicalRequest = null;
        this.canonicalHeaders = null;
        this.canonicalChartToken = (this.canonicalChartToken || 0) + 1;
        this.sizeSystemChosen = false;
        this.sizeSystem = this.dataset.shoppingCountry === 'US' ? 'US' : 'UK';
        this.querySelector('[data-size-system]')?.addEventListener('change', event => { this.sizeSystem = event.target.value; this.sizeSystemChosen = true; this.sizePreferenceWriter?.(this.sizeSystem, this.dataset.shoppingCountry); this.updateSizeLabels(); }, { signal: this.events.signal });
        this.bodyStep = 0;
        this.setupLayers();
        if (!this.inline && (!this.dialog || typeof this.dialog.showModal !== 'function')) return;
        const options = { signal: this.events.signal };
        const chartRegion = this.querySelector('[data-guide-table]');
        const highlightColumn = (cell) => {
          const index = cell?.closest('table')?.classList.contains('marame-size-guide__table') && cell.cellIndex > 0 ? cell.cellIndex : -1;
          chartRegion?.querySelectorAll('tr').forEach(row => [...row.cells].forEach((item, column) => item.toggleAttribute('data-chart-highlight', index === column)));
        };
        chartRegion?.addEventListener('pointerover', event => highlightColumn(event.target.closest('th, td')), options);
        chartRegion?.addEventListener('pointerleave', () => highlightColumn(chartRegion.contains(document.activeElement) ? document.activeElement.closest('th, td') : null), options);
        chartRegion?.addEventListener('focusin', event => highlightColumn(event.target.closest('th, td')), options);
        chartRegion?.addEventListener('focusout', event => highlightColumn(chartRegion.contains(event.relatedTarget) ? event.relatedTarget.closest('th, td') : null), options);
        chartRegion?.addEventListener('click', event => highlightColumn(event.target.closest('th, td')), options);
        if (!this.inline) {
          this.dialog.addEventListener('click', (event) => { if (this.closing) { event.preventDefault(); event.stopImmediatePropagation(); } }, { ...options, capture: true });
          this.dialog.addEventListener('keydown', (event) => { if (this.closing) event.preventDefault(); }, options);
          this.opener.hidden = false;
          this.opener.addEventListener('click', () => this.openGuide(), options);
          this.querySelectorAll('[data-guide-close]').forEach((button) => button.addEventListener('click', () => this.closeGuide(), options));
          this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeGuide(); }, options);
          this.dialog.addEventListener('close', () => this.finishGuideClose(), options);
          this.dialog.addEventListener('pointerdown', (event) => { this.backdropDown = this.isBackdrop(event); }, options);
          this.dialog.addEventListener('click', (event) => {
            if (this.backdropDown && this.isBackdrop(event)) this.closeGuide();
            this.backdropDown = false;
          }, options);
          this.querySelector('[data-guide-back]').addEventListener('click', () => this.goBack(), options);
          window.addEventListener('hashchange', () => this.openFromHash(), options);
          queueMicrotask(() => { if (this.isConnected) this.openFromHash(); });
        }
        this.querySelectorAll('[data-guide-nav]').forEach((button) => button.addEventListener('click', () => this.setView(button.dataset.guideNav, true, true, button), options));
        this.querySelectorAll('[data-guide-topic]').forEach((button) => button.addEventListener('click', () => this.setTopic(button.dataset.guideTopic), options));
        this.querySelectorAll('[data-body-topic]').forEach((button) => button.addEventListener('click', () => this.setBodyStep(Number(button.dataset.bodyTopic)), options));
        this.querySelector('[data-body-back]')?.addEventListener('click', () => this.shiftBodyStep(-1), options);
        this.querySelector('[data-body-next]')?.addEventListener('click', () => this.shiftBodyStep(1), options);
        this.addEventListener('marame:measure-request', (event) => {
          event.stopPropagation();
          this.openMeasurementGuide(event.detail || {}, event.detail?.opener || event.target);
        }, options);
        this.querySelector('[data-measure-retry]')?.addEventListener('click', () => this.loadMeasureGuide(this.measureRequest || {}), options);
        this.setMeasurementTopics([]);
        if (this.inline) this.setView('measure', false);
        this.querySelector('[data-compare-input]').addEventListener('input', (event) => {
          const value = this.parseMeasurement(event.target.value);
          this.compareCm = value === null ? null : value * (this.unit === 'in' ? 2.54 : 1);
          event.target.setCustomValidity('');
          this.querySelector('[data-compare-results]').hidden = true;
        }, options);
        this.querySelector('[data-compare-form]').addEventListener('submit', (event) => {
          event.preventDefault();
          this.compareGarment();
        }, options);
        this.querySelectorAll('[data-unit]').forEach((button) => {
          button.addEventListener('click', () => this.setUnit(button.dataset.unit), options);
        });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.canonicalChartToken = (this.canonicalChartToken || 0) + 1;
        this.artToken = (this.artToken || 0) + 1;
        this.viewAnimation?.cancel();
        this.stopSheetMotion();
        this.stopChildMotion();
        this.guideOpen = false;
        this.querySelectorAll('marame-measure-guide').forEach(viewer => viewer.setActive?.(false));
        if (this.ownsBodyLock) document.body.classList.remove('overflow-hidden');
        if (this.dialog?.open) this.dialog.close();
      }

      isBackdrop(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      openGuide() {
        if (this.inline || (this.dialog.open && !this.closing)) return;
        const start = this.closing ? this.sheetPosition(this.sheetSpring().axis) : null;
        this.stopSheetMotion();
        this.resetChild();
        if (!this.chartBuilt) this.buildChart();
        this.loadLengthCharts();
        this.applyChartLengthScope();
        this.loadChartLengthScope();
        this.loadChartDisplay();
        this.loadSizeDisplay();
        this.prepareCanonicalChart();
        this.setView(this.measureOnly ? 'measure' : 'chart', false);
        if (!this.dialog.open) {
          this.ownsBodyLock = !document.body.classList.contains('overflow-hidden');
          document.body.classList.add('overflow-hidden');
          this.dialog.showModal();
        }
        this.guideOpen = true;
        this.dialog.inert = false;
        this.animateSheet(false, start);
      }

      sheetSpring(child = false) {
        const axis = window.matchMedia?.('(min-width: 1024px)')?.matches ? 'X' : 'Y';
        return child
          ? { axis, damping: 32, stiffness: 310, mass: 0.85 }
          : { axis, damping: 32, stiffness: 300, mass: 0.9 };
      }

      sheetPosition(axis, target = this.dialog) {
        if (!window.DOMMatrix || !window.getComputedStyle) return null;
        const transform = window.getComputedStyle(target).transform;
        if (!transform || transform === 'none') return 0;
        const matrix = new window.DOMMatrix(transform);
        const extent = target.getBoundingClientRect()[axis === 'X' ? 'width' : 'height'];
        return extent ? 100 * matrix[axis === 'X' ? 'm41' : 'm42'] / extent : null;
      }
  
      stopSheetMotion() {
        this.motionToken = (this.motionToken || 0) + 1;
        if (this.closeTimer) clearTimeout(this.closeTimer);
        this.closeTimer = null;
        this.sheetAnimation?.cancel();
        this.sheetAnimation = null;
        this.closing = false;
        this.dialog?.removeAttribute('data-closing');
      }
  
      animateSheet(exiting, start, target = this.dialog, child = false) {
        if (!target?.animate || window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return null;
        const { axis, damping, stiffness, mass } = this.sheetSpring(child);
        const alpha = damping / (2 * mass);
        const discriminant = alpha * alpha - stiffness / mass;
        const remaining = (time) => {
          if (Math.abs(discriminant) < 0.00001) return Math.exp(-alpha * time) * (1 + alpha * time);
          const omega = Math.sqrt(Math.abs(discriminant));
          if (discriminant < 0) return Math.exp(-alpha * time) * (Math.cos(omega * time) + alpha / omega * Math.sin(omega * time));
          const slow = -alpha + omega, fast = -alpha - omega;
          return (-fast * Math.exp(slow * time) + slow * Math.exp(fast * time)) / (slow - fast);
        };
        const from = start ?? (exiting ? 0 : 100), to = exiting ? 100 : 0;
        const frames = [];
        let duration = 0;
        for (let step = 0; step <= 100; step++) {
          const time = step / 100;
          const rest = remaining(time);
          frames.push({ transform: `translate${axis}(${to + (from - to) * rest}%)` });
          duration = step * 10;
          if (time > 0.25 && Math.abs(rest) < 0.001 && Math.abs(remaining(time + 0.01) - rest) < 0.0001) break;
        }
        frames[frames.length - 1] = { transform: `translate${axis}(${to}%)` };
        target.setAttribute('data-spring-motion', '');
        const animation = target.animate(frames, { duration, easing: 'linear', fill: 'both' });
        animation.finished?.catch(() => {});
        if (child) this.childAnimation = animation;
        else this.sheetAnimation = animation;
        return { animation, duration };
      }

      closeGuide() {
        if (this.closing || !this.dialog.open) return;
        const start = this.sheetPosition(this.sheetSpring().axis);
        const childStart = this.childLayer && !this.childLayer.hidden ? this.sheetPosition(this.sheetSpring(true).axis, this.childLayer) : null;
        this.stopSheetMotion();
        this.stopChildMotion();
        if (childStart !== null) this.childLayer.style.transform = `translate${this.sheetSpring(true).axis}(${childStart}%)`;
        this.viewAnimation?.cancel();
        this.closing = true;
        this.dialog.setAttribute('data-closing', '');
        const token = this.motionToken;
        const motion = this.animateSheet(true, start);
        if (!motion) { this.finishGuideClose(); return; }
        const finish = () => { if (this.closing && token === this.motionToken) this.finishGuideClose(); };
        motion.animation.finished?.then(finish, finish);
        this.closeTimer = setTimeout(finish, motion.duration + 120);
      }

      finishGuideClose() {
        if (!this.guideOpen && !this.closing) return;
        this.stopSheetMotion();
        this.guideOpen = false;
        this.querySelectorAll('marame-measure-guide').forEach(viewer => viewer.setActive?.(false));
        if (this.dialog.open) this.dialog.close();
        this.dialog.inert = false;
        this.resetChild();
        if (this.ownsBodyLock) document.body.classList.remove('overflow-hidden');
        this.ownsBodyLock = false;
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }

      openFromHash() {
        if (this.inline || window.location.hash !== '#size-guide') return;
        this.openGuide();
        const url = new URL(window.location.href);
        url.hash = '';
        window.history.replaceState(window.history.state, '', url);
      }

      setupLayers() {
        this.mainLayer = this.querySelector('[data-guide-main]');
        this.childLayer = this.querySelector('[data-guide-child]');
        this.childBody = this.querySelector('[data-guide-child-body]');
        this.childHeading = this.querySelector('[data-guide-child-heading]');
        this.viewScroll = new Map();
        this.viewOpeners = new Map();
        if (this.inline || this.measureOnly || !this.childBody) return;
        this.querySelectorAll('[data-guide-view]').forEach((panel) => {
          if (panel.dataset.guideView !== 'chart') this.childBody.append(panel);
        });
      }

      stopChildMotion() {
        this.childToken = (this.childToken || 0) + 1;
        if (this.childTimer) clearTimeout(this.childTimer);
        this.childTimer = null;
        this.childAnimation?.cancel();
        this.childAnimation = null;
        this.childClosing = false;
      }

      resetChild() {
        this.stopChildMotion();
        if (!this.childLayer) return;
        this.childLayer.hidden = true;
        this.childLayer.inert = true;
        this.childLayer.style.removeProperty('transform');
        this.mainLayer.inert = false;
        this.mainLayer.removeAttribute('aria-hidden');
        this.dialog.setAttribute('aria-labelledby', this.querySelector('[data-guide-heading]').id);
      }

      closeChild(focus, opener) {
        const start = this.sheetPosition(this.sheetSpring(true).axis, this.childLayer);
        this.stopChildMotion();
        this.viewAnimation?.cancel();
        this.childClosing = true;
        this.childLayer.inert = true;
        if (focus) this.dialog.focus?.({ preventScroll: true });
        const token = this.childToken;
        const finish = () => {
          if (!this.childClosing || token !== this.childToken || this.closing) return;
          this.resetChild();
          this.querySelectorAll('[data-guide-view]').forEach((panel) => { panel.hidden = panel.dataset.guideView !== 'chart'; });
          if (focus) {
            const target = opener?.isConnected ? opener : this.querySelector('[data-guide-heading]');
            target.focus({ preventScroll: true });
          }
        };
        const motion = this.animateSheet(true, start, this.childLayer, true);
        if (!motion) { finish(); return; }
        motion.animation.finished?.then(finish, finish);
        this.childTimer = setTimeout(finish, motion.duration + 120);
      }

      setView(view, focus = true, remember = true, opener = null) {
        if (this.measureOnly || (this.dataset.category === 'footwear' && view === 'find')) view = 'measure';
        if (!['chart', 'measure', 'compare', 'find'].includes(view) || this.closing) return;
        if (view === 'find') this.loadFitFinder();
        this.querySelector('[data-guide-view="measure"] > marame-measure-guide')?.setActive?.(view === 'measure');
        this.querySelector('[data-guide-view="find"] marame-measure-guide')?.setActive?.(view === 'find');
        const previous = this.currentView;
        const layered = !this.inline && !this.measureOnly && this.childLayer && this.childBody;
        const returning = remember === false;
        const restoreOpener = this.viewOpeners?.get(previous);
        if (layered && previous && previous !== 'chart') this.viewScroll.set(previous, this.childBody.scrollTop);
        if (view === 'chart') this.viewHistory = [];
        else if (remember && previous && previous !== view) {
          (this.viewHistory ||= []).push(previous);
          this.viewOpeners?.set(view, opener);
        }
        this.currentView = view;
        this.dataset.guideActive = view;
        if (layered) {
          if (view === 'chart' && !this.childLayer.hidden && !this.childClosing) {
            this.closeChild(focus, restoreOpener);
            return;
          }
          const start = this.childClosing ? this.sheetPosition(this.sheetSpring(true).axis, this.childLayer) : null;
          const entering = this.childLayer.hidden || this.childClosing;
          this.stopChildMotion();
          this.querySelectorAll('[data-guide-view]').forEach((panel) => { panel.hidden = panel.dataset.guideView !== 'chart' && panel.dataset.guideView !== view; });
          if (view === 'chart') {
            this.resetChild();
            if (focus) this.querySelector('[data-guide-heading]').focus({ preventScroll: true });
            return;
          }
          this.childLayer.hidden = false;
          this.childLayer.inert = false;
          this.mainLayer.inert = true;
          this.childHeading.textContent = this.dataset[`${view}Title`];
          this.dialog.setAttribute('aria-labelledby', this.childHeading.id);
          if (view === 'measure' && !returning) this.setTopic('body');
          this.childBody.scrollTop = returning ? this.viewScroll.get(view) || 0 : 0;
          const panel = [...this.querySelectorAll('[data-guide-view]')].find((item) => item.dataset.guideView === view);
          if (entering) {
            this.viewAnimation?.cancel();
            this.animateSheet(false, start, this.childLayer, true);
          } else this.animateView(panel);
          if (focus) {
            const target = returning && restoreOpener?.isConnected ? restoreOpener : this.childHeading;
            target.focus({ preventScroll: true });
          }
          this.mainLayer.setAttribute('aria-hidden', 'true');
          return;
        }
        this.querySelectorAll('[data-guide-view]').forEach((panel) => { panel.hidden = panel.dataset.guideView !== view; });
        const back = this.querySelector('[data-guide-back]');
        if (back) back.hidden = this.measureOnly || view === 'chart';
        const actions = this.querySelector('[data-guide-actions]');
        if (actions) actions.hidden = view !== 'chart';
        const title = this.querySelector('[data-guide-heading]');
        title.textContent = this.dataset[view === 'chart' || (this.measureOnly && this.footwearConversionProfile) ? 'mainTitle' : `${view}Title`];
        this.querySelector('[data-guide-body]').scrollTop = 0;
        if (view === 'measure') this.setTopic('body');
        const active = [...this.querySelectorAll('[data-guide-view]')].find((panel) => panel.dataset.guideView === view);
        this.animateView(active);
        if (focus) title.focus({ preventScroll: true });
      }

      goBack() {
        if (this.childClosing || this.closing) return;
        if (this.currentView === 'find' && this.querySelector('[data-fit-finder]')?.back?.()) return;
        this.setView(this.viewHistory?.pop() || 'chart', true, false);
      }

      async loadFitFinder() {
        const finder = this.querySelector('[data-fit-finder]');
        if (!finder) return;
        if (finder.start) { finder.start(); return; }
        if (this.fitLoading) return;
        this.fitLoading = true;
        try {
          await import(finder.dataset.controllerUrl);
          if (this.isConnected) finder.start?.();
        } catch {
          finder.querySelector('[data-fit-load-error]').hidden = false;
          const retry = finder.querySelector('[data-fit-retry]');
          retry.hidden = false;
          retry.onclick = () => this.loadFitFinder();
        } finally { this.fitLoading = false; }
      }

      animateView(panel, measurement = false) {
        this.viewAnimation?.cancel();
        if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
        const start = measurement ? 'translateY(5px)' : 'translateX(10px)';
        const end = measurement ? 'translateY(0)' : 'translateX(0)';
        this.viewAnimation = panel?.animate?.([{ opacity: 0, transform: start }, { opacity: 1, transform: end }], { duration: 220, easing: 'ease-out' });
      }

      setTopic(topic) {
        if (!['garment', 'body'].includes(topic)) return;
        this.topic = topic;
        this.loadMeasureGuide({ ...this.measureRequest, mode: topic });
      }

      async loadMeasureGuide(options = {}) {
        const viewer = this.querySelector('[data-guide-view="measure"] > marame-measure-guide');
        if (!viewer) return;
        this.measureRequest = { ...this.measureRequest, ...options };
        const error = this.querySelector('[data-measure-error]');
        const retry = this.querySelector('[data-measure-retry]');
        try {
          if (!viewer.select) await import(viewer.dataset.controllerUrl);
          if (!this.isConnected) return;
          viewer.select?.({ sex: viewer.dataset.sex, category: viewer.dataset.category, ...this.measureRequest, availablePoints: this.measureAvailablePoints || [] });
          viewer.setActive?.(this.currentView === 'measure');
          if (error) error.hidden = true;
          if (retry) retry.hidden = true;
        } catch {
          if (error) error.hidden = false;
          if (retry) retry.hidden = false;
        }
      }

      async openMeasurementGuide(options = {}, opener = null) {
        if (!this.inline && !this.dialog?.open) this.openGuide();
        this.measureRequest = options;
        this.setView('measure', true, true, opener);
        await this.loadMeasureGuide(options);
      }

      setMeasurementTopics(headers) {
        const available = [...this.querySelectorAll('[data-body-topic]')].map((button) => Number(button.dataset.bodyTopic));
        const known = new Set();
        const topics = new Set();
        const labels = headers.slice(1).map((label) => String(label).toLowerCase().replace(/[^a-z]+/g, ' ').trim());
        labels.forEach((label) => {
          if (/\b(chest|bust)\b/.test(label)) known.add(0);
          if (/\bwaist\b/.test(label)) known.add(1);
          if (/\b(hip|hips|seat)\b/.test(label)) known.add(2);
          if (/\b(inside leg|inseam|inner leg)\b/.test(label)) known.add(3);
          if (/\brise\b/.test(label)) known.add(4);
          if (/\bsleeve\b/.test(label)) known.add(6);
          else if (/^(total |body |garment |back |front |centre back |center back |centre front |center front )?length( cm)?$/.test(label) || /^front body length side shoulder to hem(?: hem position)?$/.test(label)) known.add(5);
        });
        const keys = ['chest', 'waist', 'hip', 'insideLeg', 'rise', 'length', 'sleeve'];
        known.forEach(step => topics.add(keys[step]));
        labels.forEach(label => {
          if (/^(shoulder|shoulders|shoulder width|shoulder to shoulder|across shoulders?)( cm)?$/.test(label)) topics.add('shoulder');
          if (/\b(torso|body rise|body girth|shoulder to crotch)\b/.test(label)) topics.add('torso');
          if (/\b(foot length|heel to toe)\b/.test(label)) topics.add('footLength');
        });
        this.measureAvailablePoints = [...topics];
        if (this.currentView === 'measure') this.loadMeasureGuide();
        const relevant = available.filter((step) => known.has(step));
        this.measurementSteps = relevant.length ? relevant : available;
        this.querySelectorAll('[data-body-topic]').forEach((button) => { button.hidden = !this.measurementSteps.includes(Number(button.dataset.bodyTopic)); });
        if (!this.measurementSteps.includes(this.bodyStep)) this.bodyStep = this.measurementSteps[0];
      }

      shiftBodyStep(direction) {
        const steps = this.measurementSteps || [...this.querySelectorAll('[data-body-topic]')].map((button) => Number(button.dataset.bodyTopic));
        const index = steps.indexOf(this.bodyStep);
        this.setBodyStep(steps[index + direction]);
      }

      setBodyStep(step) {
        const points = ['chest', 'waist', 'hip', 'insideLeg', 'rise', 'length', 'sleeve'];
        if (!Number.isInteger(step) || !points[step]) return;
        this.bodyStep = step;
        this.loadMeasureGuide({ point: points[step], mode: this.topic || 'body' });
      }

      sizeDisplayContext() {
        let sizes = [];
        try { sizes = JSON.parse(this.dataset.sizes || '[]'); } catch { /* Keep unsupported labels unchanged. */ }
        return { productId: this.dataset.productId, sex: this.dataset.illustration, category: this.dataset.measureCategory, system: this.sizeSystem, sizes, regionProfile: this.regionProfile };
      }

      displaySize(raw, context = this.sizeDisplayContext()) {
        return this.sizeDisplayHelper ? this.sizeDisplayHelper(raw, context) : String(raw ?? '');
      }

      async canonicalFitSource(context, selected = context?.selected) {
        if (!context?.locale || context.locale === 'en' || !this.dataset.canonicalUrl || !this.fitChart) return null;
        const stamp = JSON.stringify([context.productId, context.chartId, selected?.id, this.fitChart]);
        if (this.canonicalRequest?.stamp === stamp) return this.canonicalRequest.promise;
        const promise = (async () => {
          try {
            const helper = await import(this.dataset.canonicalUrl);
            const url = helper.canonicalSourceURL({ primaryRoot: this.dataset.primaryRoot, handle: this.dataset.productHandle, variantId: selected?.id, themeId: this.dataset.themeId }, location.href);
            const [source, mapping] = await Promise.all([helper.loadCanonicalSource(url), helper.loadTranslationMap(this.dataset.translationMapUrl)]);
            if (!this.isConnected) return null;
            return helper.verifiedCanonicalSource(source, this.fitChart, context, selected, mapping);
          } catch { return null; }
        })();
        this.canonicalRequest = { stamp, promise };
        const result = await promise;
        if (!result && this.canonicalRequest?.stamp === stamp) this.canonicalRequest = null;
        return result;
      }

      async prepareCanonicalChart() {
        if (!this.dataset.locale || this.dataset.locale === 'en') return;
        const token = this.canonicalChartToken = (this.canonicalChartToken || 0) + 1;
        let context;
        try { context = JSON.parse(this.querySelector('marame-fit-finder')?.dataset.context || '{}'); } catch { return; }
        const selected = this.closest?.('product-info')?.querySelector('marame-size-picker')?.currentVariant?.() || context.selected;
        const result = await this.canonicalFitSource(context, selected);
        if (!result || !this.isConnected || token !== this.canonicalChartToken) return;
        this.canonicalHeaders = result.chart.headers;
        this.canonicalChartResult = result;
        this.setMeasurementTopics(result.chart.headers);
        const actualSizes = Array.isArray(context.options) && Array.isArray(context.variants) ? context.variants.map(variant => variant.options[context.options.findIndex(name => /^(size|shoe size|shoesize)$/i.test(name))]) : [];
        const mismatch = actualSizes.some(size => !result.chart.rows.some(row => this.normaliseSize(row[0]) === this.normaliseSize(size)));
        this.compareRows = this.comparisonSource(result.chart.headers, result.chart.rows, mismatch);
        this.baseCompareRows = this.compareRows;
        this.querySelector('[data-compare-form]').hidden = !this.compareRows;
        this.querySelector('[data-compare-unavailable]').hidden = Boolean(this.compareRows);
        const compare = this.querySelector('[data-find-compare]');
        const chart = this.querySelector('[data-find-chart]');
        if (compare) compare.hidden = !this.compareRows;
        if (chart) chart.hidden = Boolean(this.compareRows);
        this.applyChartLengthScope();
        this.loadChartDisplay();
      }

      async loadChartDisplay() {
        if (!this.dataset.measurementDisplayUrl || !this.dataset.fitContextUrl || !this.fitChart) return;
        const chart = this.fitChart;
        const { context, selected } = this.chartSelection();
        const translated = this.dataset.locale && this.dataset.locale !== 'en';
        if (translated && !this.canonicalChartResult) return;
        const canonical = translated ? this.canonicalChartResult : null;
        const token = this.chartDisplayToken = (this.chartDisplayToken || 0) + 1;
        try {
          const [display, adapter] = await Promise.all([import(this.dataset.measurementDisplayUrl), import(this.dataset.fitContextUrl)]);
          if (!this.isConnected || this.fitChart !== chart || token !== this.chartDisplayToken || String(this.chartSelection().selected?.id) !== String(selected?.id)) return;
          const analysisContext = { ...context, ...(canonical?.context || {}), variants: context.variants, allowChartInference: true };
          const sourceChart = canonical?.chart || chart;
          const profile = adapter.buildProfile(sourceChart, analysisContext, selected, context.profile);
          this.applyChartSizeLabels(adapter, sourceChart, analysisContext, selected);
          const plan = display.chartDisplayPlan(sourceChart, profile, { confirmedFactorySource: true, resolveSizeLabels: (chartLabels, nativeLabels) => adapter.resolveChartSizeLabels(chartLabels, nativeLabels, analysisContext) });
          this.applyChartDisplay(plan);
        } catch { /* The untouched factory chart remains readable when the display helper is unavailable. */ }
      }

      applyChartSizeLabels(adapter, chart, context, selected) {
        const sizeIndex = (context.options || []).findIndex(name => /^(size|shoe size|shoesize)$/i.test(String(name).trim()));
        const nativeSizes = [...new Set(adapter.currentSizeVariants(context, selected).map(variant => variant.options[sizeIndex]))];
        const matches = adapter.resolveChartSizeLabels(chart.rows.map(row => row[0]), nativeSizes, context);
        if (!matches) return;
        const rows = matches.map(({ chartIndex, nativeKey }) => [nativeKey, ...chart.rows[chartIndex].slice(1)]);
        this.querySelector('[data-guide-mismatch]').hidden = true;
        const labels = new Map(matches.map(({ chartIndex, nativeKey }) => [this.normaliseSize(chart.rows[chartIndex][0]), nativeKey]));
        let labelsChanged = false;
        this.querySelectorAll('[data-raw-size]').forEach(cell => {
          const native = labels.get(this.normaliseSize(cell.dataset.rawSize));
          if (native) { labelsChanged ||= cell.dataset.rawSize !== native; cell.dataset.rawSize = native; cell.textContent = this.displaySize(native); }
        });
        if (labelsChanged) this.loadSizeDisplay();
        this.baseCompareRows = this.comparisonSource(chart.headers, rows, false);
        this.compareRows = this.baseCompareRows;
        this.querySelector('[data-compare-form]').hidden = !this.compareRows;
        this.querySelector('[data-compare-unavailable]').hidden = Boolean(this.compareRows);
        const compare = this.querySelector('[data-find-compare]');
        const chartLink = this.querySelector('[data-find-chart]');
        if (compare) compare.hidden = !this.compareRows;
        if (chartLink) chartLink.hidden = Boolean(this.compareRows);
        this.applyChartLengthScope();
      }

      applyChartDisplay(plan) {
        this.querySelectorAll('[data-chart-column]').forEach(row => {
          const column = plan.columns[Number(row.dataset.chartColumn)];
          const heading = row.children[0];
          const rawLabel = row.dataset.chartLabel || heading?.textContent || '';
          const pointLabel = column?.point ? this.dataset[`point${column.point[0].toUpperCase()}${column.point.slice(1)}`] : null;
          const label = column?.circumference ? !column.stretched && pointLabel ? pointLabel : rawLabel.replace(/\b(?:half|flat|width)\b/gi, '').replace(/\s+/g, ' ').trim() : rawLabel;
          if (heading) heading.textContent = `${column?.elasticWaist && this.dataset.waistRelaxedLabel ? this.dataset.waistRelaxedLabel : label}${column?.circumference ? ` (${this.dataset.aroundLabel})` : ''}`;
          Array.from(row.children).slice(1).forEach(cell => { cell.dataset.displayMultiplier = String(column?.multiplier || 1); });
        });
        const note = this.querySelector('[data-guide-elastic-note]');
        if (note) { note.hidden = !plan.elasticWaist; note.textContent = this.dataset.relaxedWaistNote || ''; }
        this.setUnit(this.unit || 'cm');
      }

      chartSelection() {
        let context = {};
        try { context = JSON.parse(this.querySelector('marame-fit-finder')?.dataset.context || '{}'); } catch { /* No product context on standalone educational pages. */ }
        const selected = this.closest?.('product-info')?.querySelector('marame-size-picker')?.currentVariant?.() || context.selected;
        return { context, selected };
      }

      renderSizeEquivalence(source, chart) {
        const legend = this.querySelector('[data-guide-equivalence]');
        if (!legend) return;
        const group = legend.closest('[data-guide-equivalence-group]');
        if (group) group.hidden = true;
        legend.hidden = true;
        legend.replaceChildren();
        const nodes = source.querySelectorAll('script[type="application/json"][data-aw26-size-equivalence]');
        if (nodes.length !== 1 || nodes[0].textContent.length > 1000) return;
        try {
          const data = JSON.parse(nodes[0].textContent);
          const expected = { XS: '8', S: '10', M: '12', L: '14', XL: '16', XXL: '18' };
          const { context } = this.chartSelection();
          const sizeIndex = context.options?.findIndex(name => /^(size|shoe size|shoesize)$/i.test(String(name).trim()));
          const native = [...new Set((context.variants || []).map(variant => variant.options?.[sizeIndex]))];
          const keys = Object.keys(expected);
          if (data?.version !== 1 || data.system !== 'UK' || !data.sizes || Object.keys(data.sizes).length !== keys.length || keys.some(key => data.sizes[key] !== expected[key]) || context.complete !== true || native.length !== keys.length || native.some(key => !keys.includes(key)) || chart.rows.length !== keys.length || chart.rows.some(row => !keys.includes(row[0]))) return;
          keys.forEach(size => {
            const item = document.createElement('span');
            item.className = 'marame-size-guide__equivalence-item';
            item.setAttribute('role', 'listitem');
            const label = document.createElement('span');
            label.className = 'marame-size-guide__equivalence-size';
            label.textContent = size;
            const value = document.createElement('span');
            value.className = 'marame-size-guide__equivalence-value';
            value.textContent = `UK ${data.sizes[size]}`;
            item.append(label, document.createTextNode(' '), value);
            legend.append(item);
          });
          legend.hidden = false;
          if (group) group.hidden = false;
        } catch { }
      }

      async loadLengthCharts() {
        if (!this.baseFitChart || !this.dataset.chartHtml?.includes('data-aw26-length-charts') || !this.dataset.canonicalUrl) return;
        const { context, selected } = this.chartSelection();
        const stamp = JSON.stringify([context.productId, selected?.id, selected?.options, this.dataset.chartHtml]);
        if (this.lengthChartRequest?.stamp === stamp) return this.lengthChartRequest.promise;
        const base = this.baseFitChart;
        this.fitChart = base;
        this.canonicalRequest = null;
        this.canonicalHeaders = null;
        this.canonicalChartResult = null;
        this.baseCompareRows = null;
        this.compareRows = null;
        this.canonicalChartToken = (this.canonicalChartToken || 0) + 1;
        const panel = this.querySelector('[data-guide-lengths]');
        if (panel) panel.hidden = true;
        this.querySelector('[data-compare-results]').hidden = true;
        this.applyChartLengthScope();
        const promise = (async () => {
          try {
            const [helper, adapter] = await Promise.all([import(this.dataset.canonicalUrl), import(this.dataset.fitContextUrl)]);
            if (!this.isConnected || this.baseFitChart !== base || this.lengthChartRequest?.stamp !== stamp || String(this.chartSelection().selected?.id) !== String(selected?.id)) return;
            const source = new DOMParser().parseFromString(this.dataset.chartHtml, 'text/html');
            const charts = helper.readLengthCharts(source, base, context);
            const scoped = helper.scopedLengthChart(base, charts, context, selected);
            if (!charts || scoped === base || !adapter.lengthScopeFor(context, selected, scoped).confirmed) return;
            this.lengthCharts = charts;
            this.fitChart = scoped;
            this.lengthScopeHelper = adapter.lengthScopeFor;
            this.lengthLabelHelper = adapter.isLengthMeasurementLabel;
            this.baseCompareRows = this.comparisonSource(scoped.headers, scoped.rows, false);
            this.compareRows = this.baseCompareRows;
            this.setMeasurementTopics(scoped.headers);
            this.renderLengthTabs(scoped.optionScope[0].value);
            this.applyChartLengthScope();
            this.loadChartDisplay();
            this.prepareCanonicalChart();
          } catch { }
        })();
        this.lengthChartRequest = { stamp, promise };
        return promise;
      }

      renderLengthTabs(selectedValue) {
        const container = this.querySelector('[data-guide-lengths]');
        const tabs = this.querySelector('[data-length-tabs]');
        const panel = this.querySelector('[data-length-panel]');
        if (!container || !tabs || !panel || !this.lengthCharts?.length) return;
        tabs.replaceChildren();
        this.lengthCharts.forEach((chart, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.id = `${panel.id}-tab-${index}`;
          button.textContent = chart.label;
          button.dataset.lengthValue = chart.label;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', panel.id);
          button.addEventListener('click', () => this.showLengthChart(chart.label), { signal: this.events.signal });
          button.addEventListener('keydown', event => {
            const buttons = [...tabs.querySelectorAll('[role="tab"]')];
            let target;
            if (event.key === 'ArrowRight') target = buttons[(index + 1) % buttons.length];
            if (event.key === 'ArrowLeft') target = buttons[(index + buttons.length - 1) % buttons.length];
            if (event.key === 'Home') target = buttons[0];
            if (event.key === 'End') target = buttons.at(-1);
            if (target) { event.preventDefault(); target.click(); target.focus(); }
          }, { signal: this.events.signal });
          tabs.append(button);
        });
        container.hidden = false;
        this.showLengthChart(selectedValue);
      }

      showLengthChart(label) {
        const chart = this.lengthCharts?.find(item => item.label === label);
        const panel = this.querySelector('[data-length-panel]');
        if (!chart || !panel) return;
        this.querySelectorAll('[data-length-value]').forEach(button => {
          const active = button.dataset.lengthValue === label;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          if (active) panel.setAttribute('aria-labelledby', button.id);
        });
        panel.replaceChildren();
        const sameAcrossSizes = chart.rows.every(row => row[1] === chart.rows[0][1] && row[2] === chart.rows[0][2]);
        if (sameAcrossSizes) {
          const list = document.createElement('dl');
          list.className = 'marame-size-guide__length-values';
          [this.dataset.insideLeg, this.dataset.outsideLeg].forEach((name, index) => {
            const item = document.createElement('div');
            const term = document.createElement('dt');
            term.textContent = name;
            const value = document.createElement('dd');
            const number = document.createElement('span');
            number.dataset.cm = chart.rows[0][index + 1];
            const unit = document.createElement('span');
            unit.dataset.lengthUnit = '';
            value.append(number, document.createTextNode(' '), unit);
            item.append(term, value); list.append(item);
          });
          panel.append(list);
        } else {
          const scroll = document.createElement('div');
          scroll.className = 'marame-size-guide__table-scroll';
          const table = document.createElement('table');
          table.className = 'marame-size-guide__table';
          const head = table.createTHead().insertRow();
          [this.dataset.sizeLabel, this.dataset.insideLeg, this.dataset.outsideLeg].forEach(label => {
            const cell = document.createElement('th'); cell.scope = 'col'; cell.textContent = label; head.append(cell);
          });
          const body = table.createTBody();
          chart.rows.forEach(values => {
            const row = body.insertRow();
            const size = document.createElement('th'); size.scope = 'row'; size.dataset.rawSize = values[0]; size.textContent = this.displaySize(values[0]); row.append(size);
            values.slice(1).forEach(value => { const cell = row.insertCell(); cell.dataset.cm = value; });
          });
          scroll.append(table); panel.append(scroll);
        }
        this.setUnit(this.unit || 'cm');
      }

      initialChartLengthScope(context, selected) {
        // Synchronous, conservative guard: never flash shared length figures while
        // the authoritative option-scope helper or canonical headers are loading.
        const names = Array.isArray(context?.options) ? context.options : [];
        const variants = Array.isArray(context?.variants) ? context.variants : [];
        const indexes = names.flatMap((name, index) => {
          const normal = String(name).trim().toLowerCase();
          const values = [...new Set(variants.map(variant => variant?.options?.[index]).filter(value => typeof value === 'string'))];
          return /^(length|leg length|inseam)$/.test(normal) || (normal === 'fit' && values.length > 0 && values.every(value => /^(short|regular|long|petite|tall)$/i.test(value.trim()))) ? [index] : [];
        });
        if (!indexes.length) return { required: false, confirmed: true };
        const index = indexes[0], values = [...new Set(variants.map(variant => variant?.options?.[index]).filter(value => typeof value === 'string'))];
        const selectedValue = selected?.options?.[index] ?? null;
        const invalid = indexes.length !== 1 || !values.includes(selectedValue);
        const required = invalid || values.length > 1;
        return { required, confirmed: !required, selectedValue, status: invalid ? 'invalid_selection' : required ? 'unscoped' : 'single_value' };
      }

      async loadChartLengthScope() {
        const { context, selected } = this.chartSelection();
        if (!this.dataset.fitContextUrl || !this.initialChartLengthScope(context, selected).required || this.lengthScopeLoading) return;
        this.lengthScopeLoading = true;
        try {
          const helper = await import(this.dataset.fitContextUrl);
          if (!this.isConnected) return;
          this.lengthScopeHelper = helper.lengthScopeFor;
          this.lengthLabelHelper = helper.isLengthMeasurementLabel;
          this.applyChartLengthScope();
        } catch { /* Keep the synchronous restriction when the optional helper cannot load. */ }
        finally { this.lengthScopeLoading = false; }
      }

      applyChartLengthScope() {
        const { context, selected } = this.chartSelection();
        const scope = this.lengthScopeHelper ? this.lengthScopeHelper(context, selected, this.fitChart || {}) : this.initialChartLengthScope(context, selected);
        const restricted = scope.required && !scope.confirmed;
        const notice = this.querySelector('[data-guide-length-scope]');
        if (notice) { notice.hidden = !restricted; notice.textContent = (this.dataset.lengthScopeNotice || '').replaceAll('[length]', scope.selectedValue || '—'); }
        const headers = this.canonicalHeaders || this.fitChart?.headers || [];
        const canonical = !this.dataset.locale || this.dataset.locale === 'en' || Boolean(this.canonicalHeaders);
        const isLength = this.lengthLabelHelper || (label => /\b(length|inseam|outseam|rise|torso|sleeve)\b|\b(inside|outside|inner|outer) leg\b|\bshoulder to (hem|crotch)\b/.test(String(label).toLowerCase().replace(/[^a-z]+/g, ' ').trim()));
        const wholeChartUnverified = ['mismatch', 'invalid_selection'].includes(scope.status) || (!this.lengthScopeHelper && this.fitChart?.optionScope !== undefined);
        this.querySelectorAll('[data-chart-column]').forEach(row => { row.hidden = Boolean(restricted && (wholeChartUnverified || !canonical || isLength(headers[Number(row.dataset.chartColumn)]))); });
        this.compareRows = restricted ? null : this.baseCompareRows ?? this.compareRows;
        const form = this.querySelector('[data-compare-form]'), unavailable = this.querySelector('[data-compare-unavailable]');
        if (form) form.hidden = !this.compareRows;
        if (unavailable) unavailable.hidden = Boolean(this.compareRows);
        const compare = this.querySelector('[data-find-compare]'), chart = this.querySelector('[data-find-chart]');
        if (compare) compare.hidden = !this.compareRows;
        if (chart) chart.hidden = Boolean(this.compareRows);
      }

      async loadSizeDisplay() {
        if (!this.dataset.sizeDisplayUrl) return;
        try {
          const helper = await import(this.dataset.sizeDisplayUrl);
          if (!this.isConnected) return;
          this.sizeDisplayHelper = helper.displaySize;
          this.sizeSystemHelper = helper.availableSizeSystems;
          this.countrySizeHelper = helper.sizeSystemForCountry;
          this.sizePreferenceReader = helper.readSizeSystemPreference;
          this.sizePreferenceWriter = helper.writeSizeSystemPreference;
          this.updateSizeLabels();
          const bundle = await helper.loadSizeRegions(this.dataset.sizeRegionsUrl);
          if (!this.isConnected) return;
          const rawSizes = Array.from(this.querySelectorAll('[data-raw-size]'), cell => cell.dataset.rawSize);
          this.regionProfile = helper.sizeRegionProfile(bundle, this.sizeDisplayContext(), rawSizes);
          if (this.measureOnly) {
            const context = this.sizeDisplayContext();
            this.footwearConversionProfile = helper.sizeRegionProfile(bundle, context, context.sizes);
            this.renderFootwearConversion();
          }
          this.updateSizeLabels();
        } catch { /* Original native labels remain usable. */ }
      }

      renderFootwearConversion() {
        const panel = this.querySelector('[data-footwear-conversion]');
        const container = this.querySelector('[data-footwear-conversion-table]');
        if (!panel || !container) return;
        const profile = this.measureOnly && this.footwearConversionProfile;
        panel.hidden = !profile;
        container.replaceChildren();
        if (!profile) return;
        const systems = ['UK', 'EU', 'US', 'IT', 'FR'].filter(system => profile.regions[system]);
        const table = document.createElement('table');
        table.className = 'marame-size-guide__table';
        const header = table.createTHead().insertRow();
        systems.forEach(system => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.textContent = system;
          header.append(cell);
        });
        const body = table.createTBody();
        profile.sourceSizes.forEach((size, index) => {
          const row = body.insertRow();
          systems.forEach((system, column) => {
            const cell = document.createElement(column === 0 ? 'th' : 'td');
            if (column === 0) cell.scope = 'row';
            cell.textContent = profile.regions[system][index];
            row.append(cell);
          });
        });
        container.append(table);
        if (this.currentView === 'measure') this.querySelector('[data-guide-heading]').textContent = this.dataset.mainTitle;
      }

      updateSizeLabels() {
        if (!this.sizeDisplayHelper) return;
        const cells = Array.from(this.querySelectorAll('[data-raw-size]'));
        const rawSizes = cells.map(cell => cell.dataset.rawSize);
        const available = this.sizeSystemHelper ? this.sizeSystemHelper(this.sizeDisplayContext(), rawSizes) : ['UK','US'].filter(system => rawSizes.some(raw => this.displaySize(raw, { ...this.sizeDisplayContext(), system }) !== String(raw)));
        if (!this.sizeSystemChosen || !available.includes(this.sizeSystem)) this.sizeSystem = this.sizePreferenceReader?.(this.dataset.shoppingCountry, available) || (this.countrySizeHelper ? this.countrySizeHelper(this.dataset.shoppingCountry, available) : available.includes(this.sizeSystem) ? this.sizeSystem : available[0] || 'UK');
        const context = this.sizeDisplayContext();
        cells.forEach(cell => {
          cell.textContent = this.displaySize(cell.dataset.rawSize, context);
        });
        const control = this.querySelector('[data-size-system-control]');
        if (control) control.hidden = available.length < 2;
        const selector = this.querySelector('[data-size-system]');
        if (selector) {
          if (selector.options) {
            this.sizeSystemOptions ||= Array.from(selector.options, option => ({ value:option.value, label:option.textContent }));
            const optionKey = available.join('|');
            if (this.sizeSystemOptionKey !== optionKey) {
              selector.replaceChildren(...this.sizeSystemOptions.filter(option => available.includes(option.value)).map(item => {
                const option = document.createElement('option'); option.value = item.value; option.textContent = item.label; return option;
              }));
              this.sizeSystemOptionKey = optionKey;
            }
          }
          selector.value = this.sizeSystem;
        }
        this.dispatchEvent(new CustomEvent('marame:size-labels', { bubbles:true, detail:{ productId:this.dataset.productId, system:this.sizeSystem } }));
      }

      formatMeasurement(cm, unit = this.unit || 'cm') {
        const value = unit === 'in' ? Math.round((cm / 2.54 + Number.EPSILON) * 10) / 10 : cm;
        return String(Object.is(value, -0) ? 0 : Number(value.toPrecision(12)));
      }

      parseMeasurement(value) {
        const text = String(value ?? '').trim();
        if (!/^\d+(?:[.,]\d+)?$/.test(text)) return null;
        const number = Number(text.replace(',', '.'));
        return Number.isFinite(number) && number > 0 ? number : null;
      }

      comparisonSource(headers, measurements, hasMismatch) {
        if (hasMismatch) return null;
        const indexes = headers.map((label, index) => /^(inside leg|inside leg length|inside leg seam|inseam)$/i.test(label.trim()) ? index : -1).filter((index) => index > 0);
        if (indexes.length !== 1) return null;
        const rows = measurements.map((row) => ({ size: row[0], cm: this.parseMeasurement(row[indexes[0]]) }));
        return rows.every((row) => row.cm !== null) ? rows : null;
      }

      compareGarment() {
        const input = this.querySelector('[data-compare-input]');
        if (!this.compareRows || this.compareCm === null || this.compareCm === undefined) {
          input.setCustomValidity(this.dataset.compareInvalid);
          input.reportValidity();
          return;
        }
        this.renderComparison();
        this.querySelector('[data-compare-heading]').focus({ preventScroll: true });
      }

      renderComparison() {
        const unit = this.unit || 'cm';
        const format = (cm) => this.formatMeasurement(cm, unit);
        const values = this.compareRows.map((row) => row.cm);
        const fragment = document.createDocumentFragment();
        this.compareRows.forEach((value) => {
          const row = document.createElement('tr');
          const size = document.createElement('th');
          size.scope = 'row';
          size.dataset.rawSize = value.size;
          size.textContent = this.displaySize ? this.displaySize(value.size, this.sizeDisplayContext()) : value.size;
          row.append(size);
          const length = document.createElement('td');
          length.textContent = `${format(value.cm)} ${unit}`;
          row.append(length);
          const difference = document.createElement('td');
          const delta = value.cm - this.compareCm;
          difference.textContent = Number(format(Math.abs(delta))) === 0 ? this.dataset.same : this.dataset[delta > 0 ? 'longer' : 'shorter'].replace('[value]', format(Math.abs(delta))).replace('[unit]', unit);
          row.append(difference);
          fragment.append(row);
        });
        this.querySelector('[data-compare-rows]').replaceChildren(fragment);
        this.querySelector('[data-compare-summary]').textContent = this.dataset.compareSummary.replace('[value]', format(this.compareCm)).replace('[unit]', unit);
        this.querySelector('[data-compare-same]').hidden = !values.every((value) => value === values[0]);
        this.querySelector('[data-compare-outside]').hidden = this.compareCm >= Math.min(...values) && this.compareCm <= Math.max(...values);
        this.querySelector('[data-compare-results]').hidden = false;
      }

      normaliseSize(value) {
        return String(value ?? '').trim().toUpperCase().replace(/\s+/g, ' ');
      }

      alignedChartRows(headers, rows, companionRows = []) {
        if (!Array.isArray(headers) || headers.length < 2 || !rows.length) return null;
        if (rows.every(row => row.length === headers.length)) return rows;
        const normal = value => String(value ?? '').trim().replace(/\s+/g, ' ').toUpperCase();
        if (JSON.stringify((companionRows[0] || []).map(normal)) !== JSON.stringify(headers.map(normal))) return null;
        const alternatives = companionRows.slice(1);
        const numeric = value => /^\d+(?:[.,]\d+)?$/.test(String(value).trim()) ? Number(String(value).replace(',', '.')) : NaN;
        const result = [];
        for (const row of rows) {
          if (row.length === headers.length) { result.push(row); continue; }
          if (row.length !== headers.length - 1 || row.length < 2) return null;
          const matching = alternatives.filter(other => normal(other[0]) === normal(row[0]) && other.length === headers.length);
          if (matching.length !== 1) return null;
          const reference = matching[0].slice(1).map(numeric);
          const values = row.slice(1).map(numeric);
          if (![...reference, ...values].every(value => Number.isFinite(value) && value > 0)) return null;
          const omissions = new Set();
          // 2.5 occurs in the saved legacy IN tables. It verifies position only;
          // no companion measurement is copied or used for unit conversion.
          for (const factor of [2.54, 2.5]) {
            for (let omitted = 0; omitted < reference.length; omitted++) {
              const remaining = reference.filter((_, index) => index !== omitted);
              if (values.every((value, index) => Math.abs(value - remaining[index] * factor) <= 0.031)) omissions.add(omitted);
            }
          }
          if (omissions.size !== 1 || !omissions.has(reference.length - 1)) return null;
          result.push([...row, '']);
        }
        return result;
      }

      buildChart() {
        this.chartBuilt = true;
        this.fitChart = null;
        this.baseFitChart = null;
        this.lengthChartRequest = null;
        this.lengthCharts = null;
        const lengthPanel = this.querySelector('[data-guide-lengths]');
        if (lengthPanel) lengthPanel.hidden = true;
        this.canonicalChartResult = null;
        // Parse in an inert document; copy cell text only, never source markup.
        const source = new DOMParser().parseFromString(this.dataset.chartHtml || '', 'text/html');
        const cmTables = source.querySelectorAll('table.cm-size-table');
        const cmTable = cmTables.length === 1 ? cmTables[0] : null;
        const rows = cmTable ? Array.from(cmTable.rows, (row) => Array.from(row.cells, (cell) => cell.textContent.trim())) : [];
        const headers = rows[0];
        this.setMeasurementTopics(headers || []);
        const companionTables = source.querySelectorAll('table.in-size-table');
        const companionRows = companionTables.length === 1 ? Array.from(companionTables[0].rows, row => Array.from(row.cells, cell => cell.textContent.trim())) : [];
        const measurements = this.alignedChartRows(headers, rows.slice(1).filter(row => row.some(value => value !== '')), companionRows);
        if (!measurements) {
          this.querySelector('[data-guide-missing]').hidden = false;
          return;
        }
        const sourceSizes = measurements.map((row) => this.normaliseSize(row[0]));
        if (sourceSizes.some((size) => !size) || new Set(sourceSizes).size !== sourceSizes.length) {
          this.querySelector('[data-guide-missing]').hidden = false;
          return;
        }
        let productSizes = [];
        try { productSizes = JSON.parse(this.dataset.sizes || '[]') || []; } catch { /* Leave unmatched data unclassified. */ }
        if (!Array.isArray(productSizes)) productSizes = [];
        const hasMismatch = productSizes.some((size) => !sourceSizes.includes(this.normaliseSize(size)));
        this.fitChart = { headers, rows: measurements };
        this.baseFitChart = this.fitChart;
        this.renderSizeEquivalence(source, this.fitChart);
        this.compareRows = productSizes.length ? this.comparisonSource(headers, measurements, hasMismatch) : null;
        if (this.compareRows) this.compareRows = this.compareRows.filter((row) => productSizes.some((size) => this.normaliseSize(size) === this.normaliseSize(row.size)));
        this.baseCompareRows = this.compareRows;
        this.querySelector('[data-compare-form]').hidden = !this.compareRows;
        this.querySelector('[data-compare-unavailable]').hidden = Boolean(this.compareRows);
        const legacyCompare = this.querySelector('[data-find-compare]');
        const legacyChart = this.querySelector('[data-find-chart]');
        if (legacyCompare) legacyCompare.hidden = !this.compareRows;
        if (legacyChart) legacyChart.hidden = Boolean(this.compareRows);
        this.querySelector('[data-guide-mismatch]').hidden = !hasMismatch;
        const table = document.createElement('table');
        table.className = 'marame-size-guide__table';
        const caption = table.createCaption();
        caption.dataset.unitCaption = '';
        const head = table.createTHead().insertRow();
        const corner = document.createElement('th');
        corner.scope = 'col';
        corner.textContent = this.dataset.sizeLabel;
        head.append(corner);
        measurements.forEach((row) => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.dataset.rawSize = row[0];
          cell.tabIndex = 0;
          cell.textContent = row[0];
          head.append(cell);
        });
        const body = table.createTBody();
        let canConvert = true;
        // The saved charts have sizes as rows; transpose for the Figma layout.
        headers.slice(1).forEach((label, index) => {
          const row = body.insertRow();
          row.dataset.chartColumn = String(index + 1);
          row.dataset.chartLabel = label.toLowerCase().replace(/^\w/, (letter) => letter.toUpperCase());
          const heading = document.createElement('th');
          heading.scope = 'row';
          heading.textContent = label.toLowerCase().replace(/^\w/, (letter) => letter.toUpperCase());
          row.append(heading);
          measurements.forEach((measurementsForSize) => {
            const cell = row.insertCell();
            const value = measurementsForSize[index + 1];
            cell.textContent = value || '—';
            // Only explicit numeric centimetre measurements are converted.
            if (/^\d+(?:[.,]\d+)?(?:\s*[-–]\s*\d+(?:[.,]\d+)?)?$/.test(value)) {
              cell.dataset.cm = value;
            } else if (/\d/.test(value)) {
              canConvert = false;
            }
          });
        });
        this.canConvert = canConvert;
        this.querySelectorAll('[data-unit="in"]').forEach((button) => { button.disabled = !canConvert; });
        this.querySelector('[data-guide-unit-note]').hidden = canConvert;
        this.querySelector('[data-guide-table]').replaceChildren(table);
        this.querySelector('[data-guide-content]').hidden = false;
        this.setUnit('cm');
        this.applyChartLengthScope();
      }

      setUnit(unit) {
        if (unit !== 'cm' && unit !== 'in') return;
        if (unit === 'in' && this.canConvert === false) return;
        this.unit = unit;
        this.querySelectorAll('[data-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
        this.querySelectorAll('[data-cm]').forEach((cell) => {
          const multiplier = Number(cell.dataset.displayMultiplier) === 2 ? 2 : 1;
          cell.textContent = cell.dataset.cm.replace(/\d+(?:[.,]\d+)?/g, (value) => this.formatMeasurement(Number(value.replace(',', '.')) * multiplier, unit));
        });
        const caption = this.querySelector('[data-unit-caption]');
        if (caption) caption.textContent = `${this.dataset.caption} (${unit})`;
        this.querySelectorAll('[data-compare-unit]').forEach((label) => { label.textContent = unit; });
        this.querySelectorAll('[data-length-unit]').forEach((label) => { label.textContent = unit; });
        if (this.compareCm !== null && this.compareCm !== undefined) {
          this.querySelector('[data-compare-input]').value = this.formatMeasurement(this.compareCm, unit);
          if (!this.querySelector('[data-compare-results]').hidden) this.renderComparison();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
